module.exports = __webpack_public_path__ + "c62227ced4e2480f5b33d18b044dfb79.webp";